import { supertypeClass, property, Persistable } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';

export enum AppConfigTypes {
  AUTH0_ENABLED_COVERPATH = 'AUTH0_ENABLED_COVERPATH',
  AUTH0_ENABLED_HAVEN = 'AUTH0_ENABLED',
  AUTH0_ENABLED_MMD = 'AUTH0_ENABLED_MMD',
  HEAVY_USER_ENABLED = 'HEAVY_USER_ENABLED',
}

@supertypeClass({ toClient: true, toServer: false })
export class AppConfig extends Everything {
  static TABLE_NAME = 'APP_CONFIG';

  @property()
  key: AppConfigTypes;

  @property()
  value: string;

  constructor() {
    super();
  }

  static new(key: AppConfigTypes, value: string) {
    return new AppConfig().init(key, value);
  }

  init(key: AppConfigTypes, value: string) {
    this.key = key;
    this.value = value;
    return this;
  }

  public getBooleanValue(): boolean {
    return this.value === 'true';
  }
}
